module.exports = __webpack_public_path__ + "static/media/r_itdot_16.b697d535.png";